@if(media) {
  @if(media.type === 'image'){
    <div>
      <img
        [src]="media.url"
        [alt]="'Placement Media'"
        class="min-w-3xl w-full max-h-[70vh]"
      />
    </div>
  } @else if (media.type === 'video') {
    <div>
      <video
        [src]="media.url"
        controls
        class="min-w-5xl max-h-[70vh]"
      >
        {{ 'media.browserUnsupportedVideo' | transloco }}.
      </video>
    </div>
  } @else {
    <div>
      <p>{{ 'media.unsupportedMedia' | transloco }}.</p>
    </div>
  }
}